export const regions: { labelKey: string; value: string }[] = [
  { labelKey: "region.na", value: "NA" },
  { labelKey: "region.eu", value: "EU" },
  { labelKey: "region.as", value: "AS" },
  { labelKey: "region.gl", value: "GL" },
];
